<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Lung Specific Details EMR-Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="secondarySpecification"
              class="secondarySpecification"
              disabled
              label="Secondary Specification"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="predictedTLC"
              disabled
              label="Predicted TLC"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="actualTLC"
              disabled
              label="Actual TLC "
            />
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="COMMENTS"
            />
          </div>
        </div>
    
        
   
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="FEV1"
              disabled
              label="FEV1"
            />
          </div> 

          <div class="col-2">
            <ADSTextInput
              v-model="predictedFVC"
              disabled
              label="Predicted FVC "
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="perfusionRight"
              disabled
              label="Perfusion Right"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="perfusionLeft"
              disabled
              label="Perfusion Left"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="estRVPressSYS"
              disabled
              label="Estimated RV Systolic Pressure"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="systolicPAPressure"
              disabled
              label="Systolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="diastolicPAPressure"
              disabled
              label="Diastolic PA Pressure"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="echoDate"
              disabled
              label="Echo Date"
            />
          </div>
        </div>
        
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="meanPAPressure"
              disabled
              label="Mean PA Pressure"
            />
          </div>
          
          <div class="col-4">
            <ADSTextInput
              v-model="chestCTResults"
              class="chestCTResults"
              disabled
              label="Chest CT Results"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="echoComment"
              class="echoComment"
              disabled
              label="Echo Comment"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="chestCTDate"
              disabled
              label="Chest CT Date"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="las"
              disabled
              label="LAS"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="extraCorporealLifeSupport"
              disabled
              label="ECLS"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="extraCorporealLifeSupportComment"
              disabled
              label="ECLS Comment"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="ventilator"
              class="echoComment"
              disabled
              label="Ventilator"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="ventilatorComment"
              disabled
              label="Ventilator Comment"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "LungSpecificSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      secondarySpecification: this.getSecondarySpecification( this.patientBundle ),
      predictedTLC: this.getPredictedTLC( this.patientBundle ),
      actualTLC: this.getActualTLC( this.patientBundle ),
      FEV1: this.getFEV1( this.patientBundle ), 
      predictedFVC: this.getPredictedFVC( this.patientBundle ), 
      comments: this.getComments( this.patientBundle ),
      perfusionRight: this.getPerfusionRight( this.patientBundle ),
      perfusionLeft: this.getPerfusionLeft( this.patientBundle ),
      estRVPressSYS: this.getESTRVPressSYS( this.patientBundle ),
      systolicPAPressure: this.getSystolicPAPressure( this.patientBundle ),
      diastolicPAPressure: this.getDiastolicPAPressure( this.patientBundle ),
      meanPAPressure: this.getMeanPAPressure( this.patientBundle ),
      echoComment: this.getEchoComment( this.patientBundle ),
      echoDate: this.getEchoDate( this.patientBundle ),
      chestCTResults: this.getChestCTResults( this.patientBundle ),
      chestCTDate: this.getChestCTDate( this.patientBundle ),
      las: this.getLAS( this.patientBundle ),
      extraCorporealLifeSupport: this.getExtraCorporealLifeSupport( this.patientBundle ),
      extraCorporealLifeSupportComment: this.getExtraCorporealLifeSupportComment( this.patientBundle ),
      ventilator: this.getVentilator( this.patientBundle ),
      ventilatorComment: this.getVentilatorComment( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) { 
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getSecondarySpecification( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8210' );
    },
    getPredictedTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8213' );
    },
    getActualTLC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8214', );
    },
    getFEV1( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8231' );
    },
    getPredictedFVC( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8230' );
    },
    getComments( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8232' );
    },
    getPerfusionRight( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8211' );
    },
    getPerfusionLeft( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8212' );
    },
    getESTRVPressSYS( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8215' );
    },
    getSystolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8216' );
    },
    getDiastolicPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8217' );
    },
    getMeanPAPressure( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8218' );
    },
    getEchoComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8221' );
    },
    getEchoDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8220', 'valueDateTime' );
    },
    getChestCTResults( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8223' );
    },
    getChestCTDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8222', 'valueDateTime' );
    },
    getLAS( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8219' );
    },
    getExtraCorporealLifeSupport( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8226', 'valueBoolean' );
    },
    getExtraCorporealLifeSupportComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8227' );
    },
    getVentilator( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8228', 'valueBoolean' );
    },
    getVentilatorComment( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8229' );
    },
  },
};

</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1200px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.secondarySpecification .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.comments .afflo-ds-form-control) {
  width: 700px;
} 

:deep(.echoComment .afflo-ds-form-control) {
  width: 300px;
} 

:deep(.chestCTResults .afflo-ds-form-control) {
  width: 300px;
} 

</style>
